// src/components/partner/EditCohortModal.jsx



import {

  useEffect,

  useState,

} from "react";



import {

  CalendarDays,

  Users,

  X,

} from "lucide-react";



import {

  PROGRAMME_TYPE_OPTIONS,

  updatePartnerCohort,

} from "../../lib/partner/partnerCohorts";



import {

  fetchPartnerMemberCohortResponsibilities,

  setPartnerMemberCohortResponsibilities,

} from "../../lib/partner/partnerTeam";





const ASSIGNABLE_ROLES = [

  "owner",

  "admin",

  "cohort_manager",

  "facilitator",

  "viewer",

];





const EMPTY_FORM = {

  name: "",

  programmeType: "",

  startDate: "",

  endDate: "",

  capacity: "",

};





function formFromCohort(

  cohort

) {

  if (!cohort) {

    return EMPTY_FORM;

  }





  return {

    name:

      cohort.name ||

      "",



    programmeType:

      cohort.programme_type ||

      "other",



    startDate:

      cohort.start_date ||

      "",



    endDate:

      cohort.end_date ||

      "",



    capacity:

      cohort.capacity ??

      "",

  };

}





function roleLabel(

  role

) {

  switch (role) {

    case "owner":
      return "Owner";

    case "admin":
      return "Administrator";

    case "cohort_manager":

      return "Programme manager";



    case "facilitator":

      return "Facilitator";



    case "viewer":

      return "Viewer";



    default:

      return "Team member";

  }

}





export default function EditCohortModal({

  open,

  cohort,

  teamMembers = [],

  canManageTeam = false,

  onClose,

  onUpdated,

}) {

  const [

    form,

    setForm,

  ] = useState(

    EMPTY_FORM

  );





  const [

    responsibilityByMemberId,

    setResponsibilityByMemberId,

  ] = useState({});



  const [

    initialResponsibilityByMemberId,

    setInitialResponsibilityByMemberId,

  ] = useState({});



  const [

    loadingTeamResponsibilities,

    setLoadingTeamResponsibilities,

  ] = useState(false);





  const [

    saving,

    setSaving,

  ] = useState(false);





  const [

    error,

    setError,

  ] = useState("");





  const eligibleTeamMembers =

    (

      Array.isArray(

        teamMembers

      )

        ? teamMembers

        : []

    )

      .filter(

        (member) =>

          member.status ===

            "active" &&

          ASSIGNABLE_ROLES.includes(

            member.role

          )

      )

      .sort(

        (a, b) => {

          const roleOrder = {
            owner: 1,
            admin: 2,
            cohort_manager: 3,
            facilitator: 4,
            viewer: 5,
          };





          const roleDifference =

            (

              roleOrder[

                a.role

              ] || 99

            ) -

            (

              roleOrder[

                b.role

              ] || 99

            );





          if (

            roleDifference !==

            0

          ) {

            return roleDifference;

          }





          return String(

            a.full_name ||

              a.email ||

              ""

          ).localeCompare(

            String(

              b.full_name ||

                b.email ||

                ""

            )

          );

        }

      );





  /* ------------------------------------------------------------------------ */

  /* Lifecycle                                                                */

  /* ------------------------------------------------------------------------ */



  useEffect(() => {

    if (

      !open ||

      !cohort

    ) {

      return undefined;

    }



    let cancelled = false;



    setForm(

      formFromCohort(

        cohort

      )

    );



    setError("");

    setSaving(false);



    async function loadResponsibilities() {

      if (!canManageTeam) {

        setResponsibilityByMemberId({});

        setInitialResponsibilityByMemberId({});

        return;

      }



      try {

        setLoadingTeamResponsibilities(true);



        const entries =

          await Promise.all(

            eligibleTeamMembers.map(

              async (member) => {

                const rows =

                  await fetchPartnerMemberCohortResponsibilities(

                    member.partner_member_id

                  );



                const row =

                  rows.find(

                    (item) =>

                      String(

                        item.cohort_id

                      ) ===

                      String(

                        cohort.id

                      )

                  );



                return [

                  String(

                    member.partner_member_id

                  ),

                  {

                    isProgrammeManager:

                      Boolean(

                        row?.is_programme_manager

                      ),

                    isFacilitator:

                      Boolean(

                        row?.is_facilitator

                      ),

                  },

                ];

              }

            )

          );



        if (cancelled) {

          return;

        }



        const next =

          Object.fromEntries(

            entries

          );



        setResponsibilityByMemberId(

          next

        );



        setInitialResponsibilityByMemberId(

          next

        );

      } catch (loadError) {

        if (!cancelled) {

          console.error(

            "Loading cohort staff responsibilities failed:",

            loadError

          );



          setError(

            loadError?.message ||

              "The cohort staff responsibilities could not be loaded."

          );

        }

      } finally {

        if (!cancelled) {

          setLoadingTeamResponsibilities(false);

        }

      }

    }



    loadResponsibilities();



    return () => {

      cancelled = true;

    };

  }, [

    open,

    cohort,

    canManageTeam,

    teamMembers,

  ]);



  useEffect(() => {

    if (!open) {

      return undefined;

    }





    const handleEscape = (

      event

    ) => {

      if (

        event.key ===

          "Escape" &&

        !saving

      ) {

        onClose?.();

      }

    };





    window.addEventListener(

      "keydown",

      handleEscape

    );





    return () => {

      window.removeEventListener(

        "keydown",

        handleEscape

      );

    };

  }, [

    open,

    saving,

    onClose,

  ]);





  if (

    !open ||

    !cohort

  ) {

    return null;

  }





  /* ------------------------------------------------------------------------ */

  /* Form                                                                     */

  /* ------------------------------------------------------------------------ */



  function updateField(

    field,

    value

  ) {

    setForm(

      (current) => ({

        ...current,



        [field]:

          value,

      })

    );

  }





  function handleBackdropClick(

    event

  ) {

    if (

      event.target ===

        event.currentTarget &&

      !saving

    ) {

      onClose?.();

    }

  }





  function selectResponsibilityMember(

    field,

    partnerMemberId

  ) {

    const selectedId =

      String(

        partnerMemberId ||

          ""

      );



    setResponsibilityByMemberId(

      (current) => {

        const next = {

          ...current,

        };



        eligibleTeamMembers.forEach(

          (member) => {

            const memberId =

              String(

                member.partner_member_id

              );



            const existing =

              next[memberId] || {

                isProgrammeManager:

                  false,

                isFacilitator:

                  false,

              };



            next[memberId] = {

              ...existing,

              [field]:

                selectedId !== "" &&

                memberId ===

                  selectedId,

            };

          }

        );



        return next;

      }

    );

  }



  const selectedProgrammeManagerId =

    eligibleTeamMembers.find(

      (member) =>

        Boolean(

          responsibilityByMemberId[

            String(

              member.partner_member_id

            )

          ]?.isProgrammeManager

        )

    )?.partner_member_id ||

    "";



  const selectedFacilitatorId =

    eligibleTeamMembers.find(

      (member) =>

        Boolean(

          responsibilityByMemberId[

            String(

              member.partner_member_id

            )

          ]?.isFacilitator

        )

    )?.partner_member_id ||

    "";



  /* ------------------------------------------------------------------------ */

  /* Save team assignment changes                                             */

  /* ------------------------------------------------------------------------ */



  const cohortIsArchived =

    cohort?.status ===

      "archived";





  async function saveTeamAssignments() {

    if (

      !canManageTeam ||

      cohortIsArchived

    ) {

      return;

    }



    const changedMembers =

      eligibleTeamMembers.filter(

        (member) => {

          const memberId =

            String(

              member.partner_member_id

            );



          const before =

            initialResponsibilityByMemberId[

              memberId

            ] || {

              isProgrammeManager:

                false,

              isFacilitator:

                false,

            };



          const after =

            responsibilityByMemberId[

              memberId

            ] || {

              isProgrammeManager:

                false,

              isFacilitator:

                false,

            };



          return (

            before.isProgrammeManager !==

              after.isProgrammeManager ||

            before.isFacilitator !==

              after.isFacilitator

          );

        }

      );



    await Promise.all(

      changedMembers.map(

        (member) => {

          const memberId =

            String(

              member.partner_member_id

            );



          const next =

            responsibilityByMemberId[

              memberId

            ] || {

              isProgrammeManager:

                false,

              isFacilitator:

                false,

            };



          return setPartnerMemberCohortResponsibilities(

            {

              partnerMemberId:

                member.partner_member_id,

              cohortId:

                cohort.id,

              isProgrammeManager:

                next.isProgrammeManager,

              isFacilitator:

                next.isFacilitator,

            }

          );

        }

      )

    );

  }



  async function handleSubmit(

    event

  ) {

    event.preventDefault();





    try {

      setSaving(true);

      setError("");





      await updatePartnerCohort({

        cohortId:

          cohort.id,



        name:

          form.name,



        programmeType:

          form.programmeType,



        startDate:

          form.startDate,



        endDate:

          form.endDate,



        capacity:

          form.capacity,



        // The RPC signature still accepts status for compatibility,

        // but the backend now determines Active/Completed from dates.

        // Archived cohorts stay archived.

        status:

          cohortIsArchived

            ? "archived"

            : "active",

      });





      await saveTeamAssignments();





      await onUpdated?.();



      onClose?.();

    } catch (

      submitError

    ) {

      console.error(

        "Update cohort failed:",

        submitError

      );





      setError(

        submitError?.message ||

          "The cohort could not be updated."

      );

    } finally {

      setSaving(false);

    }

  }





  const teamEditingDisabled =

    saving ||

    loadingTeamResponsibilities ||

    cohortIsArchived;





  /* ------------------------------------------------------------------------ */

  /* Render                                                                   */

  /* ------------------------------------------------------------------------ */



  return (

    <div

      role="presentation"

      onMouseDown={

        handleBackdropClick

      }

      className="fixed inset-0 z-[100] flex items-end justify-center bg-black/45 p-0 sm:items-center sm:p-6"

    >

      <div

        role="dialog"

        aria-modal="true"

        aria-labelledby="edit-cohort-title"

        className="max-h-[95vh] w-full overflow-y-auto rounded-t-[28px] bg-white shadow-2xl sm:max-w-2xl sm:rounded-[28px]"

      >



        {/* Header */}



        <header className="flex items-start justify-between border-b border-[#EFEFEF] px-6 py-5">



          <div>

            <p className="text-xs font-black uppercase tracking-[0.14em] text-[#FF914D]">

              Partner cohort

            </p>



            <h2

              id="edit-cohort-title"

              className="mt-1 text-2xl font-black text-[#333333]"

            >

              Edit cohort

            </h2>



            <p className="mt-1 text-sm text-[#757575]">

              Update cohort details

              and manage the team

              assigned to this

              programme.

            </p>

          </div>





          <button

            type="button"

            onClick={

              onClose

            }

            disabled={

              saving

            }

            aria-label="Close edit cohort form"

            className="flex h-10 w-10 items-center justify-center rounded-full text-[#757575] transition hover:bg-[#FFF4EC] hover:text-[#FF914D] disabled:opacity-50"

          >

            <X className="h-5 w-5" />

          </button>



        </header>





        <form

          onSubmit={

            handleSubmit

          }

          className="space-y-5 p-6"

        >



          {error && (

            <div

              role="alert"

              className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700"

            >

              {error}

            </div>

          )}





          {/* Cohort name */}



          <div>

            <label

              htmlFor="edit-cohort-name"

              className="block text-sm font-black text-[#333333]"

            >

              Cohort name

            </label>



            <input

              id="edit-cohort-name"

              value={

                form.name

              }

              onChange={(

                event

              ) =>

                updateField(

                  "name",

                  event.target

                    .value

                )

              }

              disabled={

                saving

              }

              required

              maxLength={

                120

              }

              className="mt-2 w-full rounded-2xl border border-[#DDDDDD] px-4 py-3 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

            />

          </div>





          {/* Programme type */}



          <div>

            <label

              htmlFor="edit-cohort-programme-type"

              className="block text-sm font-black text-[#333333]"

            >

              Programme type

            </label>



            <select

              id="edit-cohort-programme-type"

              value={

                form.programmeType

              }

              onChange={(

                event

              ) =>

                updateField(

                  "programmeType",

                  event.target

                    .value

                )

              }

              disabled={

                saving

              }

              required

              className="mt-2 w-full rounded-2xl border border-[#DDDDDD] bg-white px-4 py-3 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

            >

              {PROGRAMME_TYPE_OPTIONS.map(

                (option) => (

                  <option

                    key={

                      option.value

                    }

                    value={

                      option.value

                    }

                  >

                    {option.label}

                  </option>

                )

              )}

            </select>

          </div>





          {/* Lifecycle note */}



          <div className="rounded-2xl border border-[#FFE1CF] bg-[#FFF9F5] px-4 py-3">

            <p className="text-xs font-semibold leading-relaxed text-[#757575]">

              Cohort status is managed automatically from the dates. Future cohorts show as Upcoming, current cohorts are Active, and cohorts become Completed after their end date.

            </p>

          </div>





          {/* Dates */}



          <div className="grid gap-4 sm:grid-cols-2">



            <div>

              <label

                htmlFor="edit-cohort-start-date"

                className="block text-sm font-black text-[#333333]"

              >

                Start date

              </label>



              <div className="relative mt-2">

                <CalendarDays className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#999999]" />



                <input

                  id="edit-cohort-start-date"

                  type="date"

                  value={

                    form.startDate

                  }

                  onChange={(

                    event

                  ) =>

                    updateField(

                      "startDate",

                      event.target

                        .value

                    )

                  }

                  disabled={

                    saving

                  }

                  className="w-full rounded-2xl border border-[#DDDDDD] py-3 pl-11 pr-4 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

                />

              </div>

            </div>





            <div>

              <label

                htmlFor="edit-cohort-end-date"

                className="block text-sm font-black text-[#333333]"

              >

                End date

              </label>



              <div className="relative mt-2">

                <CalendarDays className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#999999]" />



                <input

                  id="edit-cohort-end-date"

                  type="date"

                  value={

                    form.endDate

                  }

                  min={

                    form.startDate ||

                    undefined

                  }

                  onChange={(

                    event

                  ) =>

                    updateField(

                      "endDate",

                      event.target

                        .value

                    )

                  }

                  disabled={

                    saving

                  }

                  className="w-full rounded-2xl border border-[#DDDDDD] py-3 pl-11 pr-4 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

                />

              </div>

            </div>



          </div>





          {/* Capacity */}



          <div>

            <label

              htmlFor="edit-cohort-capacity"

              className="block text-sm font-black text-[#333333]"

            >

              Learner capacity

            </label>



            <input

              id="edit-cohort-capacity"

              type="number"

              min="1"

              step="1"

              value={

                form.capacity

              }

              onChange={(

                event

              ) =>

                updateField(

                  "capacity",

                  event.target

                    .value

                )

              }

              disabled={

                saving

              }

              placeholder="Unlimited"

              className="mt-2 w-full rounded-2xl border border-[#DDDDDD] px-4 py-3 text-sm outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15"

            />

          </div>





          {/* Team responsibilities */}



          {canManageTeam && (

            <section className="border-t border-[#EFEFEF] pt-5">



              <div className="flex items-start gap-3">



                <div className="flex h-10 w-10 flex-none items-center justify-center rounded-2xl bg-[#FFF4EC] text-[#FF914D]">

                  <Users className="h-5 w-5" />

                </div>



                <div>

                  <h3 className="font-black text-[#333333]">

                    Cohort responsibilities

                  </h3>



                  <p className="mt-1 text-sm leading-relaxed text-[#757575]">

                    Choose who should act as
                    Programme Manager,
                    Facilitator, or both for
                    this cohort. Their main
                    Partner team role does not
                    change.

                  </p>

                </div>



              </div>



              <div className="mt-4 grid gap-4 rounded-[22px] border border-[#E5E5E5] bg-[#FAFAFA] p-4 sm:grid-cols-2">

                {loadingTeamResponsibilities ? (

                  <div className="text-sm font-semibold text-[#757575] sm:col-span-2">

                    Loading team responsibilities…

                  </div>

                ) : eligibleTeamMembers.length ===

                0 ? (

                  <div className="sm:col-span-2">

                    <p className="font-black text-[#333333]">

                      No active team members

                    </p>

                    <p className="mt-1 text-sm text-[#757575]">

                      Add an active Partner team member first.

                    </p>

                  </div>

                ) : (

                  <>

                    <label className="block">

                      <span className="text-xs font-black uppercase tracking-[0.08em] text-[#666666]">

                        Programme Manager

                      </span>

                      <select

                        value={

                          selectedProgrammeManagerId

                        }

                        onChange={(event) =>

                          selectResponsibilityMember(

                            "isProgrammeManager",

                            event.target.value

                          )

                        }

                        disabled={

                          teamEditingDisabled

                        }

                        className="mt-2 w-full rounded-2xl border border-[#DDDDDD] bg-white px-4 py-3 text-sm font-semibold text-[#333333] outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15 disabled:cursor-not-allowed disabled:opacity-60"

                      >

                        <option value="">

                          Unassigned

                        </option>

                        {eligibleTeamMembers.map(

                          (member) => (

                            <option

                              key={

                                member.partner_member_id

                              }

                              value={

                                member.partner_member_id

                              }

                            >

                              {member.full_name ||

                                member.email ||

                                "Team member"}

                              {member.role

                                ? ` — ${roleLabel(

                                    member.role

                                  )}`

                                : ""}

                            </option>

                          )

                        )}

                      </select>

                    </label>



                    <label className="block">

                      <span className="text-xs font-black uppercase tracking-[0.08em] text-[#666666]">

                        Facilitator

                      </span>

                      <select

                        value={

                          selectedFacilitatorId

                        }

                        onChange={(event) =>

                          selectResponsibilityMember(

                            "isFacilitator",

                            event.target.value

                          )

                        }

                        disabled={

                          teamEditingDisabled

                        }

                        className="mt-2 w-full rounded-2xl border border-[#DDDDDD] bg-white px-4 py-3 text-sm font-semibold text-[#333333] outline-none transition focus:border-[#FF914D] focus:ring-4 focus:ring-[#FF914D]/15 disabled:cursor-not-allowed disabled:opacity-60"

                      >

                        <option value="">

                          Unassigned

                        </option>

                        {eligibleTeamMembers.map(

                          (member) => (

                            <option

                              key={

                                member.partner_member_id

                              }

                              value={

                                member.partner_member_id

                              }

                            >

                              {member.full_name ||

                                member.email ||

                                "Team member"}

                              {member.role

                                ? ` — ${roleLabel(

                                    member.role

                                  )}`

                                : ""}

                            </option>

                          )

                        )}

                      </select>

                    </label>



                    <p className="text-xs leading-relaxed text-[#8A8A8A] sm:col-span-2">

                      The same team member can be selected for both responsibilities.

                    </p>

                  </>

                )}

              </div>



              <p className="mt-3 text-xs leading-relaxed text-[#8A8A8A]">

                These cohort responsibilities
                are separate from each person's
                organisation-level Partner role.

              </p>



          {cohortIsArchived && (

                <p className="mt-2 text-xs font-semibold text-amber-700">

                  Team assignments cannot

                  be changed while the

                  cohort is archived.

                </p>

              )}



            </section>

          )}





          {/* Actions */}



          <div className="flex flex-col-reverse gap-3 border-t border-[#EFEFEF] pt-5 sm:flex-row sm:justify-end">



            <button

              type="button"

              onClick={

                onClose

              }

              disabled={

                saving

              }

              className="rounded-full border border-[#DDDDDD] px-5 py-3 text-sm font-black text-[#555555] transition hover:bg-[#F7F7F7] disabled:opacity-50"

            >

              Cancel

            </button>





            <button

              type="submit"

              disabled={

                saving

              }

              className="rounded-full bg-[#FF914D] px-6 py-3 text-sm font-black text-white transition hover:bg-[#E9782F] disabled:cursor-not-allowed disabled:opacity-60"

            >

              {saving

                ? "Saving changes…"

                : "Save changes"}

            </button>



          </div>



        </form>



      </div>

    </div>

  );

}